import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f12542f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-summary shadowboxing" }
const _hoisted_2 = { class: "settings-summary-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-summary-title ibf-h2" }, "Summary", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "settings-summary-table" }
const _hoisted_6 = {
  key: 0,
  class: "settings-summary-table-inner-items-container"
}
const _hoisted_7 = { class: "settings-summary-table-subtitle ibf-button2" }

import { useRouter } from 'vue-router';
import { useSettingsSummaryLinux, useSettingsSummaryWindows } from '@/views/settings/settings.helpers';
import { reactive } from 'vue';
import { useOsService } from '@/services/OsService/OsService';
import SettingsSummaryRow from './settingsSummaryRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'settings-summary',
  setup(__props) {

const osService = useOsService();
const router = useRouter();
const { summary } = osService?.isWindows.value ? useSettingsSummaryWindows() : useSettingsSummaryLinux();
const data = reactive({
  activeConfig: 'General',
});

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_q_scroll_area, {
        class: "settings-summary-scroller",
        "thumb-style": { borderRadius: '3px', width: '6px', background: 'rgba(127, 135, 137, 0.4)', right: '0px', opacity: '1' }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(summary)), (settings, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "settings-summary-items"
            }, [
              _createElementVNode("div", {
                class: "settings-summary-item-title",
                onClick: 
              () => {
                data.activeConfig = settings;
                _unref(router).push({ name: `settings.${settings}` });
              }
            
              }, _toDisplayString((_unref(summary) as any)[settings].Name), 9, _hoisted_4),
              _createElementVNode("table", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(summary) as any)[settings].items, (item, settingIndex) => {
                  return (_openBlock(), _createElementBlock("div", { key: settingIndex }, [
                    (item.items)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(item.Name), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (innerItem, innerItemIndex) => {
                            return (_openBlock(), _createBlock(SettingsSummaryRow, {
                              key: innerItemIndex,
                              item: innerItem,
                              onClick: 
                    () => {
                      data.activeConfig = settings;
                      _unref(router).push({ name: `settings.${settings}` });
                    }
                  
                            }, null, 8, ["item", "onClick"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock(SettingsSummaryRow, {
                          key: 1,
                          item: item,
                          onClick: 
                  () => {
                    data.activeConfig = settings;
                    _unref(router).push({ name: `settings.${settings}` });
                  }
                
                        }, null, 8, ["item", "onClick"]))
                  ]))
                }), 128))
              ]),
              (index !== Object.keys(_unref(summary)).length - 1)
                ? (_openBlock(), _createBlock(_component_q_separator, {
                    key: 0,
                    class: "settings-summary-separator",
                    spaced: "12px"
                  }))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["thumb-style"])
    ])
  ]))
}
}

})